// extracted by mini-css-extract-plugin
export var numpadContainer = "_hf-1";
export var phoneButton = "_hf-0";